class ProductViewersCount extends HTMLElement {
  connectedCallback() {
    const countEl = this.querySelector('[ref="count"]');
    if (!countEl) return;

    const min = Number(this.dataset.min) || 1;
    const max = Number(this.dataset.max) || min;
    const vary = this.dataset.vary === 'true';
    const storageKey = `product-viewers-count:${this.dataset.productKey || ''}`;

    let count = Number(sessionStorage.getItem(storageKey));
    if (!count || count < min || count > max) {
      count = Math.floor(Math.random() * (max - min + 1)) + min;
      sessionStorage.setItem(storageKey, String(count));
    }

    countEl.textContent = String(count);

    if (!vary) return;

    this.interval = window.setInterval(() => {
      const step = Math.random() < 0.5 ? -1 : 1;
      count = Math.min(max, Math.max(min, count + step));
      sessionStorage.setItem(storageKey, String(count));
      countEl.textContent = String(count);
    }, 4000);
  }

  disconnectedCallback() {
    if (this.interval) window.clearInterval(this.interval);
  }
}

customElements.define('product-viewers-count', ProductViewersCount);
